import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=2e99d1dd&scoped=true&"
import script from "./Side.vue?vue&type=script&lang=js&"
export * from "./Side.vue?vue&type=script&lang=js&"
import style0 from "@/common.css?vue&type=style&index=0&id=2e99d1dd&scoped=true&lang=css&"
import style1 from "./Side.vue?vue&type=style&index=1&id=2e99d1dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99d1dd",
  null
  
)

export default component.exports